import {
  LegalEntityUser,
  PhysicalEntityUser,
} from 'modules/registerPage/components/common/RegistrationUser';
import { axiosInstance } from './axios';
import { REACT_APP_API_SERVER_URL } from './constants';

export const registerPrivateIndividual = async (user: PhysicalEntityUser) => {
  const body = { ...user };
  const response = await axiosInstance.post(
    `${REACT_APP_API_SERVER_URL}/api/register/private-individual`,
    body,
  );

  return response.status === 200 || response.status === 201;
};

export const registerLegalEntity = async (user: LegalEntityUser) => {
  const body = { ...user };
  const response = await axiosInstance.post(
    `${REACT_APP_API_SERVER_URL}/api/register/legal-entity`,
    body,
  );

  return response.status === 200 || response.status === 201;
};
